import { currentStepId } from '../helper';
import React from 'react';
import styles from '../product-timeline.module.scss';
import OutlineView from './outline';
import StepInfo from './step-info';
import { Order } from '../interfaces/myOrder';
import { Product } from '../interfaces/orderSaleProduct';
import { Timeline, TimelineStep } from '../interfaces/timeline';

const StepView: React.FC<{
  order: Order | null;
  product: Product;
  step: TimelineStep;
  timeline: Timeline;
}> = ({ product, order, step, timeline }) => {
  const { identifier, status } = step;

  const currentStep = status === 'pending' || status === 'ongoing' || status === 'cancelled';

  return (
    <div
      key={identifier}
      id={currentStep ? currentStepId : ''}
      className={styles.ordersSales__mainRight__steps__step}
    >
      <OutlineView step={step} />
      <StepInfo
        order={order}
        product={product}
        step={step}
        timeline={timeline}
      />
    </div>
  );
};

export default StepView;
